<ng-container *ngIf="showLoadingSpinner">
  <px-loading-spinner></px-loading-spinner>
</ng-container>
<ng-container *ngIf="!showLoadingSpinner">
  <px-usage-internet-details-container
    id="internetUsageDetails"
    [usageProduct]="usageProduct"
  ></px-usage-internet-details-container>
</ng-container>
